'use client';

import {
  Toaster as ChakraToaster,
  Icon,
  Portal,
  Spinner,
  Stack,
  Toast,
  createToaster,
} from '@chakra-ui/react';
import TickIconFilled from 'src/assets/icons/TickIconFilled';
import WarningTriangleFilled from 'src/assets/icons/WarningTriangleFilled';
import colors from 'src/theme/colors';

export const toaster = createToaster({
  placement: 'bottom-start',
  pauseOnPageIdle: true,
  max: 3,
});

function Indicator({ type }: { type?: string }) {
  if (type === 'loading') {
    return <Spinner size="sm" color="blue.solid" />;
  }
  if (type === 'error') {
    return <ErrorIcon />;
  }
  if (type === 'warning') {
    return <WarningTriangleFilled />;
  }
  return <TickIconFilled />;
}

export function Toaster() {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {toast => (
          <Toast.Root width={{ md: 'sm' }}>
            <Indicator type={toast.type} />
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
            </Stack>
            {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
            {toast.meta?.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
}

function ErrorIcon() {
  return (
    <Icon width="20px" height="20px">
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="10" fill="url(#paint0_linear_1667_2355)" />
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="9.5"
          stroke={colors.white}
          strokeOpacity="0.1"
        />
        <path
          d="M7 7L13 13"
          stroke={colors.white}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 7L7 13"
          stroke={colors.white}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1667_2355"
            x1="10"
            y1="20"
            x2="10"
            y2="-3.72529e-08"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={colors.podcastRed600} />
            <stop offset="1" stopColor={colors.podcastRed400} />
          </linearGradient>
        </defs>
      </svg>
    </Icon>
  );
}
